import type { FaireProductEntity } from "../../entity_types/product";

export const p_htwj676bsm: FaireProductEntity = {
  token: "p_htwj676bsm",
  type: "product",
  name: "Lavender Soy Candle Baby Shower Favor ",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/cb8f17b12cca38dcda696cc056064e5581726b0c9baf99a3d11266c6dafdb91f.jpeg",
  priceDollars: 0.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
